import React from "react";
import Header from "./../components/Header";
import ShopSection from "./../components/homeComponents/ShopSection";
// import ContactInfo from "./../components/homeComponents/ContactInfo";
import CalltoActionSection from "./../components/homeComponents/CalltoActionSection";
import Footer from "./../components/Footer";
// import Deck from "./../components/homeComponents/Banner"
import { useParams } from "react-router-dom";

const HomeScreen = () => {
  const { keyword, pagenumber } = useParams();
  window.scrollTo(0, 0);
  return (

    <div>

      <Header />
      {/* <Deck/> */}
      <ShopSection keyword={keyword} pagenumber={pagenumber} />
      <CalltoActionSection />
      {/* <ContactInfo /> */}
      <Footer />
    </div>
  );
};

export default HomeScreen;
